<template>
    <v-app v-if="isLoading">
        <loading />
    </v-app>
    <v-card
        v-else
        class="EK-card EK-shadow IMTOrange text-center rounded-xl rounded-tr-0 border-top border-right"
    >
        <v-data-table
            dense
            :headers="headers"
            :items="contactsCustomerList"
            hide-default-footer
            :search="searchText"
            :items-per-page="12"
            :page.sync="page"
            @page-count="pageCount = $event"
        >
            <template v-slot:top>
                <v-text-field
                    v-model="searchText"
                    color="IMThemeGray"
                    style="width: 280px"
                    append-icon="mdi-magnify"
                    label="بحث في الجدول"
                    class="mx-4"
                ></v-text-field>
            </template>
            <template v-slot:item="{ item, index }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <tr v-on="on" v-bind="attrs" 
                        @click="getDetails(contactsCustomerList.findIndex(contact => contact.id == item.id), item.id)" :class="{active: (page-1)*10+index == customersIndex,newOrder: !item.isRead}" >
                            <td>
                                {{ item.userFirstName }}
                            </td>
                            <td>
                                {{ item.userLastName }}
                            </td>
                            <td class="text-order">
                                <span>
                                    {{ item.text }}
                                </span>
                            </td>
                            <td>
                                {{ 
                                    new Date(item.createdAt).toLocaleTimeString("ar-GB") 
                                    + " " + 
                                    new Date(item.createdAt).toISOString().substr(0, 10)
                                }}
                            </td>
                            <td>
                                <v-btn @click="onConfirmDelete(item.id, index)" text>
                                    <img src="/media/svg/table/delete.svg" alt="delete" />
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                    <span>انقر لعرض التفاصيل</span>
                </v-tooltip>
            </template>
        </v-data-table>
        <v-pagination
            color="IMThemeGray"
            v-model="page"
            :total-visible="7"
            :length="pageCount"
        ></v-pagination>
    </v-card>
</template>
<style lang="scss" scoped>
.active {
    background: rgba(0, 0, 0, .125)!important;
}
.text-order{
    span{
        margin: auto;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        width: 200px;
        text-overflow: ellipsis;
    }
}
.newOrder {
     background: #ffddc9 !important;
}
</style>
<script>
import loading from "@/components/loading";
import { mapGetters, mapActions } from 'vuex';
export default {
    props: {
        customersIndex: String
    },
    data:() => ({
        page: 1,
        pageCount: 0,
        searchText: "",
        headers: [
            {
                text: "الاسم",
                value: "userFirstName",
            },
            {
                text: "الكنية",
                value: "userLastName",
            },
            {
                text: "شكوى/ اقتراح",
                value: "type",
            },
            {
                text: "تاريخ الإرسال",
                value: "createdAt",
            },
            {
                text: "حذف",
                value: "delete",
                sortable: false
            }
        ]
    }),
    components:{
        loading
    },
    created(){
        this.$store.dispatch('fetchContactsCustomer');
    },
    computed: {
        ...mapGetters(['contactsCustomerList', "isLoading"])
    },
    methods: {
        ...mapActions(["deleteContactsCustomer","setReadContact"]),
        getDetails(index, id){
            this.setReadContact(id);
            if(index != this.customersIndex){
                this.$router.push(`/contact/customers/${index}`);
            }
        },
        onConfirmDelete(id, index) {
            this.deleteContactsCustomer({id, index})
        }
    }
}
</script>